import NewsPage from "../news/NewsPage";
import Mpdata from "../../pages/mp/Mpdata";

const Dharm = () => {
  return (
    <NewsPage
      category="dharm"
    />
  );
};

export default Dharm;
